const basins = [
    {"HUC8":"04150500","name":"St. Francois River"},
    {"HUC8":"04150407","name":"Missiquoi River",},
    {"HUC8":"04150408","name":"Lake Champlain"},
    {"HUC8":"04150405","name":"Lamoille River"},
    {"HUC8":"04150403","name":"Winooski River"},
    {"HUC8":"04150402","name":"Otter Creek"},
    {"HUC8":"04150401","name":"Mettawee River"},
    {"HUC8":"04150409","name":"Richelieu River"},               //small
    {"HUC8":"01080101","name":"Upper Connecticut"},             //aka Headwaters Connecticut River
    {"HUC8":"01080102","name":"Passumpsic"},
    {"HUC8":"01080103","name":"Waits"},                         //aka Ammonoosuc River-Connecticut River
    {"HUC8":"01080104","name":"Uper Connecticut-Mascoma"},      //aka Waits River-Connecticut River
    {"HUC8":"01080105","name":"White"},
    {"HUC8":"01080106","name":"Black-Ottauquechee"},            //aka Black River-Connecticut River
    {"HUC8":"01080107","name":"West"},
    {"HUC8":"01080203","name":"Deerfield"},
    {"HUC8":"01080201","name":"Middle Connecticut"},	        //aka Ashuelot River-Connecticut River
    {"HUC8":"02020003","name":"Hudson-Hoosic"},
    // in the streamflow file, some different basin ids are used, so these are added so getUsgsSfPtsl filter will obtain all VT basin data
    {"HUC8":"02010001","name":"Lake George"},                   //maps to 04150401
    {"HUC8":"02010002","name":"Otter"},                         //maps to 04150402
    {"HUC8":"02010003","name":"Winooski"},                      //maps to 04150403
    {"HUC8":"02010004","name":"Ausable"},                       //maps to 04150408
    {"HUC8":"02010005","name":"Lamoille"},                      //maps to 04150405
    {"HUC8":"02010006","name":"Great Chazy-Saranac"},           //maps to 04150408
    {"HUC8":"02010007","name":"Missiquoi"},                     //maps to 04150407
    {"HUC8":"01110000","name":"St. Francois"},                  //maps to 04150500
];



const usdmCategoryColors = [
    "#730000",
    "#E60000",
    "#FFAA00",
    "#FCD37F",
    "#FFFF00",
    "gainsboro",
    "#267300",
    "#BEE8FF",
    "#00A9E6",
    "#005CE6",
    "#002673",
];

const usgsCategoryColors = [
      'red',
      'darkred',
      'darkorange',
      'lime',
      'cyan',
      'blue',
      'black'
  ];

const spicolors = [
    { "color": usdmCategoryColors[10], "range": [2.0, 1000] },
    { "color": usdmCategoryColors[9], "range": [1.6, 2.0] },
    { "color": usdmCategoryColors[8], "range": [1.3, 1.6] },
    { "color": usdmCategoryColors[7], "range": [0.8, 1.3] },
    { "color": usdmCategoryColors[6], "range": [0.5, 0.8] },
    { "color": usdmCategoryColors[5], "range": [-0.5, 0.5] },
    { "color": usdmCategoryColors[4], "range": [-0.8, -0.5] },
    { "color": usdmCategoryColors[3], "range": [-1.3, -0.8] },
    { "color": usdmCategoryColors[2], "range": [-1.6, -1.3] },
    { "color": usdmCategoryColors[1], "range": [-2.0, -1.6] },
    { "color": usdmCategoryColors[0], "range": [-1000, -2.0] },
];

/*const pctlColors = [
    { color: "#b30000", range: [-1, 2] },
    { color: "#ff6600", range: [2, 10] },
    { color: "#ffc000", range: [10, 20] },
    { color: "#ffff99", range: [20, 30] },
    { color: "#66ff66", range: [30, 70] },
    { color: "#8acdff", range: [70, 80] },
    { color: "#569ad0", range: [80, 90] },
    { color: "#1c669d", range: [90, 98] },
    { color: "#6800b3", range: [98, 100] },
    { color: "lightgray", range: [-1000,1000] }
];*/
    
const spiColorSelect = (val) => {
    let color = "white";
    spicolors.forEach((e) => {
        if (val > e.range[0] && val <= e.range[1]) {
            color = e.color;
        }
    })
    return color;
}

const getIdsByBasin = (results, spiSaved, setSpiSaved, setPanelError) => {
    const spi_data = results.data;
    const now = new Date();
    const sdate = now.getFullYear() - 1 + "-01-01";
    const edate = now.getFullYear() + "-12-31";
    let markers = {'30-day': [], '60-day': [], '90-day': [], '120-day': []};

    // make all basin metacalls at once
    Promise.all(
    	basins.map(rec => 
            fetch("https://data.rcc-acis.org/StnMeta", {
                    headers: { "Content-Type": "application/json" },
                    method: "POST",
                    body: JSON.stringify({"basin":rec.HUC8, "meta":["sids","name","state"], sdate:sdate, edate:edate, elems:"pcpn"}),
            }).then(res => res.json())
        )
    )
        // then process the results basin by basin
        .then(allResults => {
            allResults.forEach((results) => {       //each basin
                results.meta.forEach(md => {        //each station metadata record
                    let ghcnid = ""
                    for (const sid of md.sids) {    //sids array in station metadata
                        const [id, idtype] = sid.split(' ')
                        if (idtype === "6") {
                            ghcnid = id;
                            break;
                        }
                    }
                    // get spi keyed on ghcn id
                    if (ghcnid !== "" && spi_data.hasOwnProperty(ghcnid)) {
                        const stndata = spi_data[ghcnid]
                        Object.keys(markers).forEach((timeperiod) => {
                          if (stndata[timeperiod]) {
                            const spi = stndata[timeperiod].spi;
                            markers[timeperiod].push({
                              position: stndata.position, 
                              fillColor: spiColorSelect(spi), 
                              data: md.name + (md.state !== "VT" ? (", " + md.state) : "") + "<br/>" + timeperiod + " SPI: " + spi
                            });
                          }
                        })
                    }
                })
            })
            //got all markers/all basins; save to state
            setSpiSaved({...spiSaved, markers:markers, date: results.date});
        })
        .catch(err => {
            console.log("Basin metadata retrieval error: " + err);
            setPanelError(true);
        }); 
}

export const getSpiPts = (spiDataFile, spiSaved, setSpiSaved, setPanelError) => {
    const options = { headers: { "Content-Type": "application/json" } };
    fetch(spiDataFile, options)
      .then(res => res.json())
      .then(results => {
        getIdsByBasin(results, spiSaved, setSpiSaved, setPanelError)
        setPanelError(false);
      })
      .catch(err => {
        console.log("SPI retrieval error: " + err)
        setPanelError(true);
      });
}

export const getUsgsGwPts = async (usgsFileName, gwSaved, setGwSaved, setPanelError) => {
    const allmarkers = [];
    const options = { headers: { "Content-Type": "application/json" } };
    try {
        const res = await fetch(usgsFileName, options);
        if (!res.ok) {
            throw new Error('Res not ok');
        }    
        const contentType = res.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            throw new Error('Response is not JSON');
        }
        const results = await res.json();
        const vtBasins = basins.map(b => { return b.HUC8 });
        results.data.forEach(stn => {
            if (stn.name.slice(0,2) === "VT" || vtBasins.includes(stn.basin)) {
                const usdmcat = stn.usdm;
                const href_usdm = "'https://nedews.nrcc.cornell.edu/gw/?id=" + stn.siteid + "&cats=usdm'";
                //const usgscat = stn.usgs
                //href1 = "https://waterdata.usgs.gov/monitoring-location/" + f.siteid + "/#parameterCode=72019&period=P365D"
                 //const href2_usgs = "https://nedews.nrcc.cornell.edu/gw/?id=" + f.siteid + "&cats=default"
                allmarkers.push({
                    position: stn.position, 
                    basin: stn.basin,
                    fillColor: usdmCategoryColors[usdmcat], 
                    data: stn.name + "<br/>Measurement date: " + stn.mdate + "<br/><a href=" + href_usdm + " target='_blank' rel='noreferrer'>Percentile graph (new tab)</a>"
                });
            }
        })
        setGwSaved({...gwSaved, markers:allmarkers, date:results.date})
        setPanelError(false);
    } catch (err) {
        console.log("Groundwater retrieval error: " + err);
        setPanelError(true);
    }
}

export const getUsgsSfPts = async (usgsFileNames, sfSaved, setSfSaved, setPanelError) => {
    let allmarkers = {'1-Day': [], '7-Day': [], '14-Day': [], '28-Day': []};
    const options = { headers: { "Content-Type": "application/json" } };
    const vtBasins = basins.map(b => { return b.HUC8 });
    Object.keys(allmarkers).forEach(async (period) => {
        try {
            const res = await fetch(usgsFileNames[period], options);
            if (!res.ok) {
                throw new Error('Res not ok');
            } 
            const contentType = res.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new Error('Response is not JSON');
            }
            const results = await res.json();
            results.data.forEach(stn => {
                if (stn.name.slice(-2) === "VT" || vtBasins.includes(stn.basin.slice(0, 8))) {
                    const usgscat = stn.class;
                    const href = "'https://waterdata.usgs.gov/monitoring-location/USGS-" + stn.siteid + "/statistical-graphs/'";
                    allmarkers[period].push({
                        position: stn.position, 
                        basin: stn.basin.slice(0, 8),
                        fillColor: usgsCategoryColors[usgscat], 
                        data: stn.data[0] + "<br/>Measurement date: " + stn.data[1] + "<br/><a href=" + href + " target='blank' rel='noreferrer'>USGS site page (new tab)</a>"
                    });
                }
            })
            setSfSaved({...sfSaved, markers:allmarkers, date:results.date})
            setPanelError(false);
        } catch (err) {
            console.log("Streamflow retrieval error: " + err);
            setPanelError(true);
        }
    })
}
